import React from "react"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { confirmAlert } from "react-confirm-alert"
import { validateForm } from "../../../../../../services/validation"
import { saveCommunityActivities } from "../../../../../../services/plans"
import RequestSupport from "../../../../components/RequestSupport"
import configs from "../../../../../../configs"

import Tooltip from "../../../../../../components/Tooltip"
import Form, { Group, Input, TextArea } from "../../../../../../components/Form"
import Repeater from "../../../../components/Repeater"
import Button from "../../../../../../components/Button"
import InfoCard, {
  InfoCardItem,
  InfoCardTitle,
  InfoCardDescription,
  InfoCardLabel
} from "../../../../components/InfoCard"

class CommunityActivities extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      communityActivities: [],
      form: {
        title: {
          label: "Activity Title",
          name: "title",
          type: "text",
          value: "",
          required: true
        },
        content: {
          label: "How Will This Activity Improve Your Life",
          name: "content",
          type: "textarea",
          value: "",
          required: true
        }
      },
      isSubmitted: false,
      formIsHidden: true,
      currentId: null,
      requestSupportIsHidden: true
    }
  }

  componentDidMount() {
    this.updateCommunityActivities()
  }

  componentDidUpdate(prevProps) {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.communityActivities) {
      if (
        JSON.stringify(prevProps.store.plan.answers.communityActivities) !==
        JSON.stringify(plan.answers.communityActivities)
      ) {
        this.updateCommunityActivities()
      }
    }
  }

  requestSupportToggle = () => {
    const { requestSupportIsHidden } = this.state

    this.setState({ requestSupportIsHidden: !requestSupportIsHidden })
  }

  updateCommunityActivities = () => {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.communityActivities) {
      this.setState(
        {
          communityActivities: plan.answers.communityActivities
        },
        () => {
          this.openFormByUrlParameter()
        }
      )
    }
  }

  openFormByUrlParameter = () => {
    const {
      id,
      history,
      store: { plan }
    } = this.props

    if (id !== undefined && plan.answers.communityActivities) {
      plan.answers.communityActivities.map(item => {
        if (id === item.id) {
          history.push("/pre-plan/community-activities")
          this.onFormOpen(null, item.id, item)
        }

        return null
      })
    }
  }

  scrollToInvalidElement = fields => {
    Object.keys(fields).map((resKey, index) => {
      if (fields[resKey].message && index === 0) {
        const item = this.form.elements[resKey]
        const parent = item.closest
          ? item.closest(".form_group")
          : item[0].closest(".form_group")
        const offSet = parent.getBoundingClientRect().top + window.pageYOffset
        const supportsNativeSmoothScroll =
          "scrollBehavior" in document.documentElement.style

        if (supportsNativeSmoothScroll) {
          window.scrollTo({
            top: offSet,
            behavior: "smooth"
          })
        } else {
          window.scrollTo(0, offSet)
        }
      }

      return null
    })
  }

  handleNext = () => {
    const { onNext } = this.props
    onNext()
  }

  handleBack = () => {
    const { onBack } = this.props
    onBack()
  }

  getItem = id => {
    const { form } = this.state

    return {
      id: id || null,
      title: form.title.value,
      content: form.content.value
    }
  }

  removeItem = index => {
    const { communityActivities } = this.state
    const {
      onSaveCommunityActivities,
      store: { user, plan }
    } = this.props

    const newCommunityActivities = communityActivities.filter(item => {
      const communityActivitie = item

      if (item.id === index) {
        return false
      }

      return communityActivitie
    })

    const deleteItem = () => {
      onSaveCommunityActivities(
        user.token,
        plan.id,
        newCommunityActivities
      ).then(() => {
        this.setState({
          formIsHidden: true
        })
      })
    }

    confirmAlert({
      title: "Are you sure?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            deleteItem()
          }
        },
        {
          label: "No"
        }
      ]
    })
  }

  changeItem = () => {
    const { communityActivities, form, currentId } = this.state
    const {
      scrollToNav,
      onSaveCommunityActivities,
      store: { user, plan }
    } = this.props

    const res = validateForm(form)

    if (Object.keys(res).length === 0 && res.constructor === Object) {
      const newItem = this.getItem(currentId)
      let newCommunityActivities

      if (currentId !== null) {
        newCommunityActivities = communityActivities.map(item => {
          let communityActivitie = item

          if (item.id === currentId) {
            communityActivitie = newItem
          }

          return communityActivitie
        })
      } else {
        newCommunityActivities = [...communityActivities, newItem]
      }

      scrollToNav()

      onSaveCommunityActivities(
        user.token,
        plan.id,
        newCommunityActivities
      ).then(() => {
        this.setState({
          formIsHidden: true
        })
      })
    } else {
      this.scrollToInvalidElement(res)

      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          ...res
        }
      })
    }
  }

  onFormOpen = (e, index, item) => {
    if (e) e.preventDefault()

    const { communityActivities, form } = this.state
    const { scrollToNav } = this.props
    let currentId
    const newForm = {}
    let value
    let res

    if (item) {
      currentId = index
      res = item
    } else if (index) {
      currentId = index
      res = communityActivities.find(({ id }) => {
        return index === id
      })
    } else {
      currentId = null
    }

    Object.keys(form).map(key => {
      const ValueTypeOf = typeof form[key].value === "string" ? "" : []

      if (!index) {
        value = ValueTypeOf
      } else if (res) {
        value = res[key]
      } else {
        value = ValueTypeOf
      }

      newForm[key] = {
        ...form[key],
        value
      }

      return null
    })

    scrollToNav()

    this.setState({
      formIsHidden: false,
      currentId,
      form: newForm
    })
  }

  onFormClose = () => {
    const { scrollToNav } = this.props

    scrollToNav()

    this.setState({
      formIsHidden: true,
      currentId: null,
      requestSupportIsHidden: true
    })
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  render() {
    const {
      form,
      formIsHidden,
      isSubmitted,
      communityActivities,
      currentId,
      requestSupportIsHidden
    } = this.state
    const {
      store: { plan, user }
    } = this.props

    const userIsGuardian = user.list_role.includes(configs.roles.Guardian)

    return (
      <>
        <div className="pre-plan_header">
          <div className="pre-plan_title">Community Activities</div>
          <div className="pre-plan_description">
            On a regular basis are you involved in any community, social,
            religious/faith, well-being activities? If involved, describe your
            activity. How often do you attend (daily, weekly, fortnightly) and
            how do you get to and back from these activities? Are there things
            that you do on an irregular basis, such as occasional trips away
            with family or friends? If yes, describe the activity and frequency.
          </div>
        </div>

        {plan.loading ? (
          <Loader
            type="TailSpin"
            color="#0c4632"
            height={80}
            width={80}
            className="loader"
          />
        ) : (
          <div className="row community-activities">
            <div className="col-xl-8 offset-xl-2">
              <Form
                formRef={el => {
                  this.form = el
                }}
              >
                {formIsHidden ? (
                  <>
                    {communityActivities.map(userA => (
                      <InfoCard
                        key={userA.id}
                        className="info-card--yellow-light"
                        hideDelete={userIsGuardian}
                        onDelete={() => {
                          this.removeItem(userA.id)
                        }}
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <InfoCardItem>
                              <InfoCardLabel>Activities</InfoCardLabel>
                              <InfoCardTitle>{userA.title}</InfoCardTitle>
                            </InfoCardItem>
                          </div>

                          <div className="col-md-8">
                            <InfoCardItem>
                              <InfoCardLabel>Service Provided</InfoCardLabel>
                              <InfoCardDescription>
                                {userA.content}
                              </InfoCardDescription>
                            </InfoCardItem>
                          </div>
                        </div>
                        <Group className="form_btn-group form_group--padding-top-lg">
                          <Button
                            button={{ type: "button" }}
                            onClick={e => {
                              this.onFormOpen(e, userA.id)
                            }}
                            className="btn--secondary-light btn--width-lg btn--height-md"
                          >
                            Edit Activity
                          </Button>
                          <Button
                            button={{ type: "button" }}
                            onClick={e => {
                              this.onFormOpen(e, userA.id)
                            }}
                            className="btn--cancel-light btn--request-support btn--width-lg btn--height-md"
                          >
                            Request Support
                          </Button>
                        </Group>
                      </InfoCard>
                    ))}

                    {!userIsGuardian && (
                      <Group>
                        <Repeater
                          text="Add A Community Activity"
                          onClick={this.onFormOpen}
                        />
                      </Group>
                    )}

                    <Group className="form_btn-group form_group--padding-top-lg text-center">
                      <Button
                        button={{ type: "button" }}
                        onClick={this.handleBack}
                        className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Back
                      </Button>

                      <Button
                        button={{ type: "button" }}
                        onClick={this.handleNext}
                        className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Next
                      </Button>
                    </Group>
                  </>
                ) : (
                  <>
                    <div className="pre-plan_form_header">
                      <div className="pre-plan_form_title">
                        Activity In Which I Am Currently Involved Or Would Like
                        To Be Involved
                      </div>
                    </div>
                    <Group>
                      <Input
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.title}
                      />
                    </Group>

                    <Group className="form_group--with-tooltip">
                      <Tooltip>
                        The benefits of activity such as an improvement to your
                        mental and physical health are perfectly acceptable
                        answers.
                      </Tooltip>

                      <TextArea
                        onChange={this.onChange}
                        isSubmitted={isSubmitted}
                        field={form.content}
                      />
                    </Group>

                    <Group className="form_btn-group form_group--padding-top-lg">
                      <Button
                        button={{ type: "button" }}
                        onClick={this.onFormClose}
                        className="btn--empty-secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Back
                      </Button>

                      <Button
                        button={{ type: "button", disabled: userIsGuardian }}
                        onClick={this.changeItem}
                        className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                      >
                        {currentId === null ? "Add Activity" : "Edit Activity"}
                      </Button>

                      {currentId !== null && (
                        <Button
                          button={{ type: "button" }}
                          onClick={this.requestSupportToggle}
                          className={`
                            btn--cancel-light 
                            btn--request-support 
                            btn--width-md 
                            btn--height-sm 
                            btn--font-size-md 
                            ${
                              !requestSupportIsHidden
                                ? "btn--request-support-active"
                                : ""
                            }
                            `}
                        >
                          Request Support
                        </Button>
                      )}
                    </Group>
                  </>
                )}
              </Form>

              {plan.answers.supportTeam && currentId && (
                <RequestSupport
                  guardians={plan.answers.supportTeam}
                  planSection="CA"
                  planSubsection={currentId}
                  isHidden={requestSupportIsHidden}
                  onToggle={this.requestSupportToggle}
                />
              )}
            </div>
          </div>
        )}
      </>
    )
  }
}

CommunityActivities.propTypes = {
  onBack: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired,
  scrollToNav: propTypes.func.isRequired,
  onSaveCommunityActivities: propTypes.func.isRequired,
  id: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        supportTeam: propTypes.arrayOf(propTypes.shape({})),
        communityActivities: propTypes.arrayOf(
          propTypes.shape({
            id: propTypes.string,
            title: propTypes.string,
            content: propTypes.string
          })
        )
      })
    })
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveCommunityActivities: (token, planId, activities) =>
    dispatch(saveCommunityActivities(token, planId, activities))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CommunityActivities)
)
